import { StandardComp } from "../atoms/standardComp";
import { HorizontalLayout, VerticalLayout } from "./layout";
import { icon } from "../functions/icons";
import { ProgressBarComplete, TimeBar } from "../molecule/timeBar";
import { act, useContext, useEffect, useRef, useState } from "react";
import { Alert } from "../components/alert";
import { TitleDescription } from "./titleDescription";
import { TitleAtom } from "../atoms/titleAtom";
import { borderRadius } from "polished";


export function QuizStepper({progressMode, quizStructure, toggleCollapse, style, goToSection, activeSection, type="default", maxReachedModule = 0, setMaxReachedModule }) {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const containerRef = useRef(null);
    const [isScrollable, setIsScrollable] = useState(false);
    useEffect(() => {
        const el = containerRef.current;
        if (el) {
        setIsScrollable(el.scrollHeight > el.clientHeight);
        }
    }, []);
    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    const handleGoToSection = (index) => {
        if (index <= maxReachedModule) {
            goToSection(index);
            setMaxReachedModule(Math.max(maxReachedModule, index)); 
            
        }
    }
    console.log("structure",activeSection)
    const totalModules = quizStructure.reduce(
        (sum, section) => sum + section.modules.length,
        0
    );
    const globalProgress =
        ((maxReachedModule + 1) / totalModules) * 100;
    return (
       <>
        {type === "default" ? (
        <StandardComp style={{ ...style, justifyContent: "flex-end", margin: "1rem 0 0 0", height: "calc(-13.5rem + 100dvh)", boxShadow: "2px 1px 5px 1px rgb(0 0 0 / 5%)", borderRadius: " 0 calc(0.8rem * var(--br-scale)) calc(0.8rem * var(--br-scale)) 0", zIndex: "2"}} editClass={"standard-margin small-padding assesment-side"} content={
            <>
                <HorizontalLayout style={{ height: "100%" }}>
                <VerticalLayout
                    ref={containerRef}
                    style={{
                    maxHeight: "calc(100dvh -10.3rem)",
                    overflowY: "auto",
                    gap: ".5rem",
                    }}
                >
                    {quizStructure.map((section, sectionIndex) => {
                    let sectionProgress = 0;
                    if (progressMode === "section") {
                        const reachedModules = section.modules.filter(
                        (m) => m.indexCounter <= maxReachedModule
                        ).length;
                        sectionProgress =
                        (reachedModules / section.modules.length) * 100;
                    } else {
                        sectionProgress = globalProgress;
                    }

                    return (
                            <QuizSection
                            key={section.id_lessons}
                            section={section}
                            type={type}
                            isScrollable={isScrollable}
                            isMobile={isMobile}
                            toggleCollapse={() => toggleCollapse(sectionIndex)}
                            goToSection={handleGoToSection}
                            activeSection={activeSection}
                            maxReachedModule={maxReachedModule}
                            progress={sectionProgress}
                            />
                        );
                    })}
                </VerticalLayout>
                </HorizontalLayout>
            </>
        } /> ) : (
            <>
            <VerticalLayout style={{ ...style ,"gap": "0.75rem"}}>
            {quizStructure.map((section, index) => {
                return (
                    <QuizSection 
                        type={type}
                        activeSection={activeSection}
                        toggleCollapse={() => toggleCollapse(index)} 
                        goToSection={(index) => goToSection(index)} 
                        key={section.id_lessons} 
                        section={section} 
                        isMobile={isMobile}
                        />
                )
            })}
        </VerticalLayout>
            </>
        )}
       </>
    )
}


function QuizSection({isScrollable, section, toggleCollapse, goToSection, isMobile, activeSection, activeModuleIndex, type, progress, maxReachedModule }) {
    const goToModule = (event, index) => {
        event.stopPropagation();
        if (index <= maxReachedModule) {
            goToSection(index);
        }
    }
    const publishPage = type === "publish"
    const isOpen = publishPage ? !section.collapsed : true;
    const anyModuleFinished = section.modules.some(m => m.finished);
return (
    <StandardComp
      onClick={publishPage ? () => toggleCollapse() : null}
      style={{
        marginRight: isScrollable ? "inherit": "0",
        background: publishPage ? "var(--white)" : "",
        padding: ".5rem 1.5rem .5rem .5rem",
        gap: ".5rem",
        cursor: publishPage ? "pointer" : "default",
        flexDirection: publishPage ? "column" : "",
      }}
      editClass={`${publishPage &&  "published"} flex ${isOpen ? "active-standard stepper-active" : ""}`}
      title={section.title}
      content={
        <>
          {!publishPage && (
            <ProgressBarComplete
              type="fill"
              progress={`${progress}%`}
              direction="vertical"
              barColor="primary-400"
            />
          )}
          {publishPage && (
            <HorizontalLayout>
              <VerticalLayout
                style={{
                  gap: "1rem",
                  width: "unset",
                  padding: "0 0.75rem 0 0",
                }}
              >
                <HorizontalLayout style={{ gap: ".5rem" }}>
                  {section.progress !== "0" ? icon("check-circle", "2rem", "var(--primary-600)") : icon("menu", "", "var(--standard-text-color)")}
                  <p className="normal-text-dark" style={{ fontWeight: "bold" }}>
                    {section.title}
                  </p>
                </HorizontalLayout>

                <TitleAtom
                  title={`${section.modules.length} LESSEN - ${
                    section.modules.length * 2.5
                  } MIN`}
                  className={`small-text-light ${
                    section.modules[activeModuleIndex]
                      ? "standard-margin-bottom"
                      : ""
                  }`}
                />
              </VerticalLayout>
              <div style={{ marginLeft: "auto" }}>
                {section.collapsed &&
                  icon("arrow-down",17 , "var(--standard-text-color)")}
              </div>
            </HorizontalLayout>
          )}
          {isMobile && section.modules[activeModuleIndex] && !anyModuleFinished && (
            <ProgressBarComplete
              type="fill"
              progress={`${section.progress}%`}
              direction="horizontal"
              barColor="primary-400"
            />
          )}
          {isOpen && (
            <VerticalLayout style={{ gap: "0.5rem" }}>
              {publishPage && (
                <ProgressBarComplete progress={`${section.progress}%`} />
              )}
              {section.modules.map((question, index) => {
                const isClickable = question.indexCounter <= maxReachedModule;
                return (
                  <StandardComp
                    key={question.id_modules}
                    style={{
                      background: publishPage ? "var(--primary-50)" : "",
                      width: "auto",
                      cursor:
                        publishPage || !isClickable ? "unset" : "pointer",
                      opacity: publishPage || isClickable ? 1 : 0.5,
                      gap: publishPage ? ".5rem" : "",
                    }}
                    onClick={(e) =>
                      !publishPage && isClickable && goToModule(e, question.indexCounter)
                    }
                    editClass={`flex ${
                      publishPage ? "" : "center"
                    } small-standard-padding no-margin ${
                      question.indexCounter === activeSection
                        ? "quiz-stepper-section-comp"
                        : ""
                    }`}
                    content={
                      <HorizontalLayout style={{ width: "auto" }}>
                        <div
                          style={{
                            marginRight: publishPage ? "0.5rem" : "",
                          }}
                        >
                          {question.finished
                            ? icon("check-circle", "1.5rem", "var(--primary-600)")
                            : icon(
                                quizType(question.module_type).icon_type,
                                "24",
                                "var(--standard-text-color)"
                              )}
                        </div>
                        {publishPage && (
                          <p
                            style={{ marginRight: "0.5rem" }}
                            className="small-text-dark"
                          >
                            <b>Module:</b> {quizType(question.module_type).type_text}
                          </p>
                        )}
                        {question.finished != null &&
                          publishPage &&
                          status(
                            question.finished,
                            question.module_type,
                            question.correct_answered
                          )}
                      </HorizontalLayout>
                    }
                  />
                );
              })}
            </VerticalLayout>
          )}
        </>
      }
    />
  );
}
function quizType(id) {
    switch (id) {
        case 1: return {type_text:"Quiz/Toets", icon_type:"clock-question-small"}
        case 2: return {type_text:"Tekstuele uitleg", icon_type:"text-size"}
        case 3: return {type_text:"Video fragment", icon_type:"add-video"}
    }
}


function status(finished, type, answer) {

    switch (type) {
        case 1:
            if (type === 1) {
                if (answer === true) {
                    return icon('check-circle', "25px","var(--success-600)")
                } else {
                    return icon('x-circle', "25px", "var(--error-600)")
                }
            }
            break;
      
        default:
         
            return;
    }
}